import React, { useContext, useEffect, useState } from "react"
import { auth } from "../../firebase/firebase";
import { onAuthStateChanged } from "firebase/auth";
import { setAnalyticsUser, setAuthState } from "../../firebase/telemetry";



const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext);
}


export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState(null);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, initialiseUser);
        return unsubscribe;
    }, [])

    async function initialiseUser(user) {
        if (user) {
            setCurrentUser({ ...user });
            setUserLoggedIn(true)
            // Ties every subsequent event to a user in GA4. SubscriptionGaurd
            // upgrades auth_state to 'premium' once entitlement resolves — this
            // is only the signed-in baseline.
            setAnalyticsUser(user.uid)
            setAuthState('signed_in')
        } else {
            setCurrentUser(null)
            setUserLoggedIn(false)
            setAnalyticsUser(null)
            setAuthState('signed_out')
        }
        setLoading(false);
    }

    const value = {
        currentUser,
        userLoggedIn,
        loading
    }

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}